<template>
  <TirPmButton
    class="router-tab-button"
    is-rounded
    :size="TirPmButtonSizeEnum.Small"
    :variant="
      currentTab === val
        ? TirPmButtonVariantEnum.PrimaryState
        : TirPmButtonVariantEnum.TertiaryState
    "
    @click="onClickTab(val)"
  >
    <template #leftSlot>
      <slot />
    </template>
    {{ props.label }}
  </TirPmButton>
</template>

<script lang="ts" setup>
import { PropType, inject } from "vue";
import {
  ModelThrowComponentsTab,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-components";

const props = defineProps({
  val: {
    default: null,
    type: [String, Number] as PropType<ModelThrowComponentsTab>,
  },
  currentTab: {
    default: null,
    type: [String, Number] as PropType<ModelThrowComponentsTab>,
  },
  label: {
    default: null,
    type: String as PropType<string | null>,
  },
});

const onClickTab: ((activeTab: ModelThrowComponentsTab) => number) | undefined =
  inject("injectFromTab");
</script>

<style lang="scss">
.router-tab-button {
  &.button--tertiary {
    border-color: var(--neutral-40, #a9abaf);
  }
}
</style>
